// var LazyLoad = require('lazyload');
$(document).ready(function () {
  checkBackToTop('#products-list', '#filters');

  // $('#navigation').removeClass('d-none');


  // ======== Form inputs validation ========
  $('.form-control[required]').not('.ignore').keyup(function () {
    if ((this.validity.typeMismatch === true || this.validity.patternMismatch === true) && this.validity.valid === false) {
      if (this.type == 'email') {
        this.setCustomValidity('Въведете правилен Email!');
      }
      return
    }
    if (this.validity.valid !== false || this.value != '') {
      this.setCustomValidity('')
    } else {
      this.setCustomValidity('Полето е задължително!');
    }
  })
  $('.form-control[required]').not('.ignore').each(function () {
    if (this.validity.valid === false) {
      this.setCustomValidity('Полето е задължително!');
    }
  })

  // $('form').submit(function () {
  //   $('input.form-control[required]').not('.ignore').each(function () {
  //     if (this.validity.valid === false) {
  //       this.setCustomValidity('Полето е задължително!');
  //     }
  //     setTimeout(() => {
  //       this.setCustomValidity('');
  //     }, 1000)
  //   })
  // })
  // ======== Form inputs validation ======== //

  // $('[data-toggle="tooltip"]').tooltip()
    $('.categories .dropdown').hover(
    function() {
      if ($(window).width() >= 992) {
        $('.categories').css('z-index', '1000')
        $(this).find('.dropdown-menu').stop().fadeIn('fast');
      }
    },
    function() {
      if ($(window).width() >= 992) {
        $('.categories').css('z-index', '')
        $(this).find('.dropdown-menu').stop().hide();
      }
    }
  );


    let nav_width = $('header #navigation .navbar-nav').width();
    // $('header #navigation .nav-item .dropdown-menu').css({
      // 'width': nav_width - $('header #navigation .highlighted').width(),
      // 'left': $('header #navigation .nav-item.highlighted').width() + 11
    // });

    

     $('#navigation-toggle').sidr({
        name: 'sidr-main',
        source: '.categories-box, #contacts-box',
        renaming: false,
        displace: false,
        onOpen: function () {
          $('.overlay').css('z-index', '1030');
          $('.overlay').fadeIn('fast');
        },
        onClose: function () {
          $('.overlay').fadeOut('fast');
          $('.overlay').css('z-index', '');
        }
      });

    $('#sidr-main .dropdown-toggle').on('click', function(e){
      e.preventDefault();

      $('#sidr-main .dropdown-toggle').not(this).removeClass('dropdown-show');
      $(this).toggleClass('dropdown-show').next().slideToggle('fast');
      // $('#sidr-main .dropdown-toggle').not('.dropdown-show').next().slideUp('fast');

      $('#sidr-main .dropdown-toggle .fas').addClass('fa-angle-down').removeClass('fa-angle-up');
      // $('#sidr-main .dropdown-toggle.dropdown-show .fas').removeClass('fa-angle-down').addClass('fa-angle-up');
    });

    $('.close-sidr').on('click', function(){
      $.sidr('close', 'sidr-main');
    });

    $(document).on('click', '.close-cart', function(e){
      $('.quick-cart-items').removeClass('cart-active');
      removeOpenedWindows()
    });


    // Mobile Menu scripts
    // mobile_menu = new Mmenu("#navbar", {
    //   "extensions": [
    //     "pagedim-black",
    //   ],
    //   "navbar": {
    //     "add": false,
    //     "title": "Категории"
    //   },
    //   // "iconbar": {
    //     //   "use": true,
    //     //   "top": [
    //       //     "<a href='#/'><i class='fas fa-home'></i></a>",
    //       //     "<a href='#/'><i class='fas fa-user'></i></a>"
    //       //   ],
    //       //   "bottom": [
    //         //     "<a href='#/'><i class='fab fa-twitter'></i></a>",
    //         //     "<a href='#/'><i class='fab fa-facebook'></i></a>",
    //         //     "<a href='#/'><i class='fab fa-linkedin'></i></a>"
    //         //   ]
    //         // },
    //         "iconPanels": true,
    //         "navbars": [
    //           {
    //             "position": "bottom",
    //             "content": [
    //               "<a class='fas fa-envelope' href='#/'></a>",
    //               "<a class='fab fa-twitter' href='#/'></a>",
    //               "<a class='fab fa-facebook' href='#/'></a>"
    //             ]
    //           },
    //           {
    //             "position": "top",
    //             "content": [
    //               "prev",
    //               "title",
    //               "close"
    //             ],
    //           }
    //         ]
    //       },
    //       {
    //         // configuration
    //         offCanvas: {
    //           clone: true
    //         }
    //       });

        $(document).on('change', '#close_check', function(e){
          var close_check = $('#close_check:checked').length;
          if (close_check == 1) {
            $('.btn-close').removeClass('disabled').removeAttr('disabled');
          }else{
            $('.btn-close').addClass('disabled').attr('disabled', 'disabled');
          }
        });

      });
      var myLazyLoad = new LazyLoad({
        elements_selector: ".lazy",
        load_delay: 300 //adjust according to use case
      });



      $('.categories-wrapper').hover(
    function() {
      $('.categories').stop().slideDown('fast');
    },
    function() {
      $('.categories').stop().slideUp('fast');
    }
  );

  $('.toggle-desc').click(function (e) {
    e.preventDefault();
      if ($(this).hasClass('visible')) {
        $('.category-description').animate({height: '158'},200).removeClass('visible');
        $(this).text('Прочети още').removeClass('visible');
      } else {
        var curHeight = $('.category-description').height();
        $('.category-description').css('height', 'auto');
        var autoHeight = $('.category-description').height();
        $('.category-description').addClass('visible').height(curHeight).animate({height: autoHeight}, 100);
        $(this).text('Скрий').addClass('visible');
      }
    })